import { BtnClasses, IconButton } from '@tcweb/connect-ui';
import { t } from '@trimble/i18n';
import { useDropdown } from '@trimble/solidjs-utils';
import { Component } from 'solid-js';

interface ActionsMenuProps {
  onEdit?(): void;
  onDelete?(): void;
}

export const MeasurementActionsMenu: Component<ActionsMenuProps> = (props) => {
  const { isOpen, toggle, ref } = useDropdown();

  return (
    <div
      class="relative"
      ref={ref}
      // Prevent parent click handler
      onClick={(e) => {
        e.preventDefault();
      }}
    >
      {/* <div class="px-3 self-stretch flex items-center"> */}
      <IconButton
        color={BtnClasses.TERTIARY}
        icon="tc-icon-more-vert"
        size="icon-medium"
        clicked={toggle}
      />
      {isOpen() && (
        <div class="absolute h-fit right-3 top-10 bg-white rounded-md shadow-lg border border-gray-200 z-dropdown">
          <modus-wc-menu aria-label="Menu" orientation="vertical" size="md">
            {props.onEdit && (
              <modus-wc-menu-item
                label={t('general.edit')}
                onClick={() => {
                  toggle();
                  props.onEdit?.();
                }}
              />
            )}
            <modus-wc-menu-item
              label={t('general.delete')}
              onClick={() => {
                toggle();
                props.onDelete?.();
              }}
            />
          </modus-wc-menu>
        </div>
      )}
    </div>
  );
};
